import React, { Component } from 'react';
import { useToggle, useAsync, } from 'react-use';
import { uniq, pick, isEmpty, last, sumBy, groupBy, keyBy, sortBy, omit, } from 'lodash';
import { Button } from 'reactstrap';
import Select from 'react-select';
import qs from 'qs';
import { Container, Draggable } from 'react-smooth-dnd';
import { arrayMoveImmutable } from 'array-move';
import { toast } from 'react-toastify';

import firebase, { functions } from '../../firebase';
import { batch, getCollectionData, } from '../../shared/firebase';
import { integerFormat } from '../../util';
import { fields } from '../../shared/models/consolidationJournalType';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import useCompanySelector from '../hooks/useCompanySelector';
import useQueryParams from '../hooks/useQueryParams';
import CompanyPage from '../hocs/CompanyPage';
import HelpLink from '../HelpLink';
import ModelFormModal from '../modals/ModelFormModal';
import ImportButton from '../ImportButton';
import ExportButton from '../ExportButton';
import CompanySyncButton from '../CompanySyncButton';
import TrialsSyncButton from '../TrialsSyncButton';
import AddButton from '../AddButton';
import EditButton from '../EditButton';
import DeleteButton from '../DeleteButton';
import QuerySelector from '../QuerySelector';

const db = firebase.firestore();
const { keys, entries } = Object;

export default CompanyPage(function CompanyAccountItems (props) {
  const { company, } = props;
  const [isDragging, toggleDragging] = useToggle(false);
  const consolidationJournalTypesRef = company.ref.collection('consolidationJournalTypes');
  const { items: consolidationJournalTypes, isLoading } = useCollectionSubscription(consolidationJournalTypesRef, [company], { detail: true });
  const sortedConsolidationJournalTypes = sortBy(consolidationJournalTypes, 'index');
  const consolidationJournalTypesById = keyBy(consolidationJournalTypes, 'id');
  const rowsForExport = sortedConsolidationJournalTypes.map(_ => pick(_, ['id', 'name']));
  const processRow = (batch, row, i) => {
    const { id, name, } = row;
    const ref = consolidationJournalTypesRef.doc(...(id ? [id] : []));
    const exists = consolidationJournalTypesById[id] != null;
    batch.set(ref, {
      name,
      ...(
        !exists && {
          index: (isEmpty(consolidationJournalTypes) ? 0 : last(consolidationJournalTypes).index) + i + 1,
          createdAt: new Date(),
        }
      ),
    }, { merge: true });
  };
  const onDrop = async ({ addedIndex, removedIndex }) => {
    const newIds = arrayMoveImmutable(sortedConsolidationJournalTypes, removedIndex, addedIndex).map(_ => _.id);
    await batch(db, newIds, (batch, id, index) => {
      batch.update(company.ref.collection('consolidationJournalTypes').doc(id), { index });
    });
  };
  const processRows = (rows) => {
    const consolidationJournalTypeNames = consolidationJournalTypes.map(_ => _.name);
    if(
      rows.map(_ => _.name).some(_ => consolidationJournalTypeNames.includes(_)) ||
      uniq(rows.map(_ => _.name)).length !== rows.length
    ) {
      toast.error('名称が重複しています');
    } else {
      return rows;
    }
  };
  return props.translate(
    <div className="company-consolidation-journal-types container">
      <div className="p-4 bg-white">
        <div className="d-flex justify-content-center mb-3">
          <h4>仕訳種別</h4>
        </div>
        <div className="mb-3 d-flex justify-content-end gap-1">
          <ImportButton disabled={isLoading} processRow={processRow} processRows={processRows} documentName="consolidationJournalType" importKey={`consolidationJournalTypes`} />
          <ExportButton screenName="仕訳種別" withoutYearMonth rows={rowsForExport} />
          <AddButton disabled={isLoading} itemRef={consolidationJournalTypesRef.doc()} FormModal={ModelFormModal} processValues={_ => ({ ..._, index: (last(sortedConsolidationJournalTypes)?.index || 0) + 1 })} formProps={{ title: '仕訳種別 追加', fields: fields({ otherItems: consolidationJournalTypes }), }} />
        </div>
        <div>
          <table className="table sticky-table">
            <thead className="thead-light text-center">
              <tr>
                <th></th>
                <th style={{ minWidth: 200 }}>名称</th>
                <th></th>
              </tr>
            </thead>
            <Container
              dragHandleSelector=".drag-handle"
              onDrop={onDrop}
              onDragStart={_ => toggleDragging(true)}
              onDragEnd={_ => toggleDragging(false)}
              dropPlaceholder={{ style: { background: 'eee', } }}
              render={(ref) => (
                <tbody ref={ref}>
                  {
                    sortedConsolidationJournalTypes.map((consolidationJournalType) => {
                      const { id, ref, name, disuses = false, } = consolidationJournalType;
                      const beforeDelete = async () => {
                        if(
                          (await getCollectionData(company.ref.collection('consolidationJournals').where('type', '==', id))).length > 0
                        ) {
                          toast.error('使用されているため、削除できません');
                          return false;
                        }
                      };

                      return (
                        <Draggable
                          key={id}
                          render={() => (
                            <tr style={{ display: !isDragging && 'table-row' }}>
                              <td style={{ width: 30 }}>
                                <div className="drag-handle text-muted cursor-pointer">
                                  <span className="fas fa-grip-vertical" />
                                </div>
                              </td>
                              <td style={{ minWidth: 200 }}>
                                {name}
                                {disuses && <div className="ml-1 badge badge-secondary">使用しない</div>}
                              </td>
                              <td className="text-nowrap text-right">
                                <EditButton itemRef={ref} FormModal={ModelFormModal} formProps={{ title: '仕訳種別 編集', fields: fields({ otherItems: consolidationJournalTypes.filter(_ => _.id !== id) }), }} />
                                <DeleteButton item={consolidationJournalType} itemRef={ref} className="ml-2" beforeDelete={beforeDelete} />
                              </td>
                            </tr>
                          )}
                        />
                      );
                    })
                  }
                </tbody>
              )}
            />
          </table>
        </div>
      </div>
    </div>
  );
});
